export default __webpack_public_path__ + "static/media/disleft.d7f63ad1.png";